module.exports = __webpack_public_path__ + "img/notes-purple.c0803226.svg";